<template>
  <div class="font-sans antialiased">
    <main>
      <router-view />
    </main>
    <AssistantChatWidget />
    <BugReportWidget />
  </div>
</template>

<script>
import AssistantChatWidget from '@/components/AssistantChatWidget.vue'
import BugReportWidget from '@/components/BugReportWidget.vue'

export default {
  name: 'App',
  components: {
    AssistantChatWidget,
    BugReportWidget,
  },
  setup() {
    return {}
  },
}
</script>
